var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-upload',{attrs:{"name":"file","disabled":_vm.disabled,"fileList":_vm.fileList,"multiple":true,"before-upload":_vm.beforeUpload},on:{"change":_vm.handleChange}},[_c('a-button',{attrs:{"disabled":_vm.disabled}},[_c('a-icon',{attrs:{"type":"upload"}}),_vm._v(" "+_vm._s(_vm.$t('上传附件'))+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }